import React from 'react';
export function componentTag(name) {
    if (name) {
        return 'ui-' + name;
    }
    return 'div';
}
export function HtmlProps(props) {
    const htmlProps = {};
    if (props.onClick) {
        htmlProps.onClick = props.onClick;
    }
    if (props.onMouseEnter) {
        htmlProps.onMouseEnter = props.onMouseEnter;
    }
    if (props.onMouseLeave) {
        htmlProps.onMouseLeave = props.onMouseLeave;
    }
    if (props.onMouseDown) {
        htmlProps.onMouseDown = props.onMouseDown;
    }
    if (props.onMouseUp) {
        htmlProps.onMouseUp = props.onMouseUp;
    }
    return htmlProps;
}
export function Component(props) {
    const elementName = componentTag(props.name);
    return React.createElement(elementName, mapReactProps(props), props.children);
}
function mapReactProps(props) {
    const elementAttrs = {};
    for (const key in props) {
        if (key === 'name') {
            continue;
        }
        if (key === 'className') {
            elementAttrs['class'] = props[key];
        }
        else {
            elementAttrs[key] = props[key];
        }
    }
    return elementAttrs;
}
